// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__G4Zmn","indicator":"Checkbox_indicator__t47_O","icon":"Checkbox_icon__70xVN"};